import { render, staticRenderFns } from "./guanlianguize.vue?vue&type=template&id=646451e0&"
import script from "./guanlianguize.vue?vue&type=script&lang=ts&"
export * from "./guanlianguize.vue?vue&type=script&lang=ts&"
import style0 from "./guanlianguize.vue?vue&type=style&index=0&id=646451e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports